export function isCaptureRoute(pathname = '') {
  return pathname === '/expenses/new' || pathname === '/trips/new';
}

export function getPwaUpdateBlocker({hasUnsavedCapture = false, draftCount = 0, isSyncing = false} = {}) {
  if (hasUnsavedCapture) return 'Finish or save the open expense or trip before updating.';
  if (isSyncing) return 'Wait for device records to finish syncing before updating.';
  if (draftCount > 0) return 'Sync or download the device records before updating.';
  return '';
}

export function shouldSyncOnResume({userId, online, visibilityState = 'visible'} = {}) {
  return Boolean(userId && online && visibilityState === 'visible');
}
